import { atom } from 'jotai';
import { getTotalCount } from '@/services/api';

// shopCode
export const shopCodeAtom = atom<string>('');

// 用户信息
export const userAtom = atom<Record<string, any>>({});

// 购物车数量
const cartCountAtom = atom(0);
export const queryCartCountAtom = atom(
  (get) => get(cartCountAtom),
  async (_, set) => {
    try {
      const res = await getTotalCount();
      set(cartCountAtom, res.data || 0);
    } catch (error) {}
  },
);
